<div class="w-full flex flex-col gap-4 mb-6">
  <lib-bread-crump-setycore class="w-full" [items]="items"> </lib-bread-crump-setycore>

  <lib-product-details-setycore
    [labels]="'lib.productDetails' | translate"
    class="w-full"
    [bank]="bank"
    [Imagesurl]="Imagesurl"
    [id]="id"
    [brand]="brand"
    [reference]="reference"
    [productName]="productName"
    [financingBadgeLabel]="'productsPage.details.financingBadge' | translate"
    [financingAmount]="totalPrice"
    [monthlyAmount]="monthlyAmount"
    [description]="productDescriptionprod"
    [state]="availability"
    [selectedMonths]="selectedMonths"
    [monthsPerStep]="monthsPerStep"
    [totalAmount]="+totalPrice"
    [buttonLabel]="buttonLabel | translate"
    [value]="value"
    [max]="max"
    [poupUpQuantity]="popQuantity"
    [showPopup]="showPopup"
    [loading]="loading"
    [isButtonsDisabled]="isButtonsDisabled"
    [showBuyNowButton]="!isConnected"
    [title]="titleprod | translate"
    [productsList]="productsList"
    [wishlistedIds]="(favoriteService.favoriteConfigurationIds$ | async) ?? []"
    (toggleWishlist)="onToggleWishlist($event)"
    [nosMgasinsUrl]="storesPageUrl"
    [specs]="specs"
    (monthChange)="onMonthChange($event)"
    (quantity)="getQuantity($event)"
    (onseeCart)="onSeeCart()"
    (oncontinueShopping)="onContinueShopping()"
    (selectedProduct)="onRlatedConfigSelect($event)"
    (addProductToCart)="addToCart()"
    (showPopupChange)="onShowPopupChange($event)"
    (brandSelected)="onBrandSelected($event)"
    (buyNow)="onBuyNow()"
  ></lib-product-details-setycore>
</div>

<!--snackbar to display after an error in order creation-->

@if (snackbar.visible) {
  <div class="relative z-[999]">
    <lib-snackbar
      [bank]="bank"
      [labels]="'lib.snackbar' | translate"
      [theme]="snackbar.theme"
      [title]="snackbar.text"
      [showIconLeft]="true"
      [showIconRight]="false"
      [position]="'bottom'"
      >
    </lib-snackbar>
  </div>
}
